import { action } from 'satcheljs/lib/legacy';
export default action('shiftAtMentionsHighlight')(function shiftAtMentionsHighlight(viewState, isIncrement) {
    var findResultCount = viewState.recipientsShown.length;
    if (isIncrement) {
        viewState.selectedRecipientIndex++;
    }
    else {
        viewState.selectedRecipientIndex--;
    }
    // Incrementing on last item loops back to the first item.
    // Decrementing on first item loops back to the last item.
    var totalOptions = findResultCount + (!!viewState.queryString && !viewState.hasSearchedDirectory ? 1 : 0);
    viewState.selectedRecipientIndex =
        (viewState.selectedRecipientIndex + totalOptions) % totalOptions;
});
//# sourceMappingURL=shiftAtMentionsHighlight.js.map